import theme from "../configs/theme";

const FMS_CONFIG = {
  key: "fms",
  name: "Facility Management System",
  basePath: "/fms",
  defaultRoute: "/dashboard",
  config: {
    theme: theme,
    appName: "Facility Management System",
  },
  routes: () => import("../apps/fms/routes"),
  menuItems: () => import("../apps/fms/menu-items"),
};

const RMS_CONFIG = {
  key: "rms",
  name: "Recovery Management System",
  basePath: "/rms",
  defaultRoute: "/bookings",
  config: {
    theme: theme,
    appName: "Recovery Management System",
  },
  routes: () => import("../apps/rms/routes"),
  menuItems: () => import("../apps/rms/menu-items"),
}

export const APP_REGISTRY = {
  fms: FMS_CONFIG,
  rms: RMS_CONFIG,
}

export const getCurrentApp = () => {
  const pathname = window.location.pathname
  const pathWithoutLang = pathname.replace(/^\/(en|ar)/, "")
  if (pathWithoutLang.startsWith("/fms") || pathname.includes("/fms")) {
    return APP_REGISTRY.fms
  }
  if (pathWithoutLang.startsWith("/rms") || pathname.includes("/rms")) {
    return APP_REGISTRY.rms
  }

  return APP_REGISTRY.fms
}

export const getAppByKey = (key) => APP_REGISTRY[key];

export const getAllApps = () => Object.values(APP_REGISTRY);

export const getAppFromPath = (path) => {
  const pathWithoutLang = path.replace(/^\/(en|ar)/, "")
  return getAllApps().find(app => 
    pathWithoutLang.startsWith(app.basePath) || path.includes(app.basePath)
  );
};

